import { MenuItem, SubMenu, FocusableItem, useHover, ControlledMenu, useClick } from '@szhsin/react-menu'
import React, { useState, useEffect, useRef } from 'react'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import '@szhsin/react-menu/dist/index.css'
import Link from 'react-router-dom/Link'

export default function ReactMenu({
  buttonText,
  buttonIcon = 'three_dots24',
  buttonIconPosition = 'start',
  buttonIconSize = 'large24',
  options,
  direction = '',
  showArrow = false,
  menuButtonCSS,
  menuCSS,
  menuItemCSS,
  subMenuButtonCSS,
  subMenuCSS,
  ariaLabel,
  isStatic = false,
  isHoverMenu = false
}) {
  const ref = useRef(null)
  const [display, setDisplay] = useState('arrow')
  const [isOpen, setOpen] = useState(false)
  const { anchorProps, hoverProps } = useHover(isOpen, setOpen)
  const anchorWithoutHoverProps = useClick(isOpen, setOpen)

  useEffect(() => {
    setDisplay(showArrow ? 'arrow' : '')
  }, [showArrow])

  let mainButtonIcon = null
  let mainButtonText = ''
  if (buttonIcon) {
    mainButtonIcon = <Icon styleModifier={styles.buttonIcon} size={buttonIconSize} name={buttonIcon} />
  }
  if (buttonText) {
    mainButtonText = <span className={styles.menuButton}>{buttonText}</span>
  }

  let menuButton = null
  if (mainButtonIcon && mainButtonText) {
    if (buttonIconPosition === 'end') {
      menuButton = (
        <React.Fragment>
          {mainButtonText}
          {mainButtonIcon}
        </React.Fragment>
      )
    } else {
      menuButton = (
        <React.Fragment>
          {mainButtonIcon}
          {mainButtonText}
        </React.Fragment>
      )
    }
  } else if (mainButtonIcon) {
    menuButton = mainButtonIcon
  } else {
    menuButton = mainButtonText
  }

  return options && options.length > 0 ? (
    <React.Fragment>
      <button
        type='button'
        {...(isHoverMenu ? { ...anchorProps } : { ...anchorWithoutHoverProps })}
        ref={ref}
        disabled={isStatic}
        aria-label={buttonText || ariaLabel}
        className={`${styles.menuButton} ${menuButtonCSS}`}>
        {menuButton}
      </button>

      <ControlledMenu
        state={isOpen ? 'open' : 'closed'}
        anchorRef={ref}
        onClose={() => setOpen(false)}
        menuClassName={`${menuCSS}`}
        className={`${styles.menu}`}
        transition={false}
        {...(direction.length > 0
          ? {
              direction: { direction },
              transition: false,
              arrow: display === 'arrow',
              offsetX: display === 'offset' && (direction === 'left' || direction === 'right') ? 12 : 0,
              offsetY: display === 'offset' && (direction === 'top' || direction === 'bottom') ? 12 : 0
            }
          : null)}
        {...(isHoverMenu ? { ...hoverProps } : {})}>
        {options.map((option, index) => {
          let text = <span className={styles.menuItem}>{option.text}</span>
          return option.hasSubMenu ? (
            <SubMenu
              key={`submenu${index}`}
              aria-label={option.ariaLabel}
              direction='right'
              className={option.className}
              menuClassName={`${subMenuCSS} `}
              arrow={false}
              label={
                option.icon ? (
                  <React.Fragment>
                    <Icon styleModifier={`${styles.icon} ${option.iconCSS}`} name={option.icon} />
                    {text}
                  </React.Fragment>
                ) : (
                  text
                )
              }>
              {option.options.map((subOption, index) => {
                return (
                  <MenuItem
                    key={`suboption${index}`}
                    className={`${menuItemCSS} ${option.className}`}
                    href={subOption.href}>
                    {subOption.text}
                  </MenuItem>
                )
              })}
            </SubMenu>
          ) : option.href ? (
            <FocusableItem disabled={isStatic} key={index} className={`${menuItemCSS} ${option.className}`}>
              {({ ref, closeMenu }) => {
                return (
                  <React.Fragment>
                    {option.image}
                    {option.isNotReactLink ? (
                      <a
                        aria-label={option.ariaLabel}
                        ref={ref}
                        href={option.href}
                        onClick={({ detail }) => closeMenu(detail === 0 ? 'Enter' : undefined)}>
                        {option.icon ? (
                          <React.Fragment>
                            <Icon styleModifier={`${styles.icon} ${option.iconCSS}`} name={option.icon} />
                            {text}
                          </React.Fragment>
                        ) : (
                          text
                        )}
                      </a>
                    ) : (
                      <Link
                        ref={ref}
                        to={option.href || '/0/myhome'}
                        aria-label={option.ariaLabel}
                        onClick={({ detail }) => closeMenu(detail === 0 ? 'Enter' : undefined)}>
                        {option.icon ? (
                          <React.Fragment>
                            <Icon styleModifier={`${styles.icon} ${option.iconCSS}`} name={option.icon} />
                            {text}
                          </React.Fragment>
                        ) : (
                          text
                        )}
                      </Link>
                    )}
                  </React.Fragment>
                )
              }}
            </FocusableItem>
          ) : (
            <MenuItem
              disabled={isStatic}
              key={index}
              className={`${menuItemCSS} ${option.className}`}
              aria-label={option.ariaLabel}
              {...(option.href ? { href: option.href } : {})}
              {...(option.onClick ? { onClick: option.onClick } : {})}>
              {option.image}
              {option.component}
              {option.icon ? (
                <React.Fragment>
                  <Icon styleModifier={`${styles.icon} ${option.iconCSS}`} name={option.icon} />
                  {text}
                </React.Fragment>
              ) : (
                text
              )}
            </MenuItem>
          )
        })}
      </ControlledMenu>
    </React.Fragment>
  ) : null
}
